import PropTypes from 'prop-types';
import CallIcon from '@material-ui/icons/Call';
import { useTranslation } from 'react-i18next';
import useGetVehicle from '../hooks/useGetVehicle';
import CustomButton from './CustomButton';
import phoneFormat from '../utils/phoneFormat';

export default function CallButton({ className }) {
  const { vehicle } = useGetVehicle();
  const { t } = useTranslation('details');

  const { directMessageEnabled, phone, whatsappNumber } = vehicle.seller;

  // Show only if it has not another contact option
  if (!process.env.FORCE_PHONE && (whatsappNumber || directMessageEnabled)) return null;

  if (!phone) return null;

  return (
    <div>
      <CustomButton
        id="callButton"
        className={className}
        variant="contained"
        size="large"
        href={`tel:${phone}`}
        target="_blank"
        startIcon={<CallIcon />}
      >
        {`${t('Call')} ${phoneFormat(phone)}`}
      </CustomButton>
    </div>
  );
}

CallButton.propTypes = {
  className: PropTypes.string,
};

CallButton.defaultProps = {
  className: '',
};
